var map = {
	"./en/hos.yml": 114,
	"./en/main.yml": 20,
	"./en/sfs.yml": 115,
	"./en/sfs2.yml": 116,
	"./fr/hos.yml": 117,
	"./fr/main.yml": 21,
	"./fr/sfs.yml": 118,
	"./fr/sfs2.yml": 119
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 113;